/** `word` without its accents: "café" → "cafe", "naïve" → "naive". Composed and decomposed forms alike. */
export function stripAccents(word: string): string {
  return word.normalize('NFD').replace(/\p{M}/gu, '')
}
